export default "__VITE_ASSET__BnUhID0v__"